<template>
	<div :class="labelClass">
		<slot></slot>
	</div>
</template>

<script>
export default {
	name: "LabelIndicator",
	props: {
		type: String,
	},
	computed: {
		labelClass() {
			if (this.type === "success") {
				return "label-indicator label-indicator__success float-left";
			}
			if (this.type === "danger") {
				return "label-indicator label-indicator__danger float-left";
			}
			return "label-indicator label-indicator__info float-left";
		},
	},
};
</script>
